import { create } from "zustand";

import {
    loadDictationMode,
    saveDictationMode,
    type DictationMode,
} from "@/lib/dictation/settings";

interface DictationSettingsStore {
    mode: DictationMode;
    hydrate: () => void;
    setMode: (mode: DictationMode) => void;
}

export const useDictationStore = create<DictationSettingsStore>((set) => ({
    mode: "dictation",
    hydrate: () => set({ mode: loadDictationMode() }),
    setMode: (mode) => {
        saveDictationMode(mode);
        set({ mode });
    },
}));
